// ============= Compact theme — user-facing copy =============

export const COMPACT_VISUAL_PROMPT_MESSAGES = {
  eyebrow: 'Guided prompts',
  sectionTitle: 'Quick tasks, done properly',
  sectionDescription:
    'Visual prompts walk you through everyday law firm tasks—rewriting comms, drafting system announcements, summarising notes, and more. You answer a few simple choices; we build a clear brief and open Ask with it ready to send.',
  howItWorksTitle: 'How it works',
  howItWorksSteps: [
    'Pick a task that matches what you need',
    'Answer short questions (audience, tone, brand rules)',
    'Review the brief, then run—it opens a new Ask chat in your chosen workspace',
  ],
  workspaceLabel: 'Run in workspace',
  workspaceHint: 'Choose where the Ask conversation should live (matter or team hub).',
  workspaceRequired: 'Select a workspace before running a prompt.',
  viewAllInLibrary: 'Open full prompt library',
  startPrompt: 'Start',
  noWorkspaces: 'Create or join a workspace to use prompts with Ask.',
  createWorkspaceCta: 'Create workspace',
  quickAccess: 'Quick access',
  allPrompts: 'All prompts',
  allPromptsAccordionHint: 'More guided tasks',
} as const;
